module.exports = __webpack_public_path__ + "static/media/ic_close.db2135c3.svg";